import { useEffect } from 'react';
import { detectThemeSync } from '../utils/themeUtils';
import useMobileView from './useMobileView';

/**
 * Syncs body theme classes for auth pages.
 * Desktop split layout (branding + light form) always uses theme-light on body
 * so global `.theme-dark p/h*` rules do not wash out the white form panel.
 */
export default function useAuthPageTheme() {
  const { isCompact } = useMobileView();
  const currentTheme = detectThemeSync();

  useEffect(() => {
    const body = document.body;
    const desktopSplit = !isCompact;

    if (desktopSplit) {
      body.classList.add('theme-light');
      body.classList.remove('theme-dark');
      return;
    }

    if (currentTheme === 'dark') {
      body.classList.add('theme-dark');
      body.classList.remove('theme-light');
    } else {
      body.classList.add('theme-light');
      body.classList.remove('theme-dark');
    }
  }, [currentTheme, isCompact]);

  return {
    isCompact,
    currentTheme,
    formPanelThemeClass: isCompact ? `theme-${currentTheme}` : 'theme-light',
  };
}
